import { OccConfig } from '@spartacus/core';

export const customOccSavedCartConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        savedCarts:
          `/b2bUsers/\${userId}/savedCarts?fields=FULL`,
        savedCart: '/b2bUsers/${userId}/carts/${cartId}/savedcart?fields=FULL',
        restoreSavedCart: '/users/${userId}/carts/${cartId}/restoresavedcart',
        cloneSavedCart: '/b2bUsers/${userId}/carts/${cartId}/clonesavedcart?name=${saveCartName}',
      },
    },
  },
};
